// Luo answer card (DESIGN.md 10.6). Body rendered as escaped text only;
// never dangerouslySetInnerHTML (AC-B-004).

import type { LuoAnswer } from '../lib/types';
import { absoluteTime } from '../lib/format';
import { toCustomerCopy } from '../lib/customerCopy';

export function LuoAnswerCard({ answer }: { answer: LuoAnswer }) {
  return (
    <div className="card" aria-label="我们的答复">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
        <strong style={{ fontSize: '0.875rem' }}>我们的答复</strong>
        <span className="mono muted" style={{ fontSize: '0.75rem' }}>{absoluteTime(answer.at)}</span>
      </div>
      <p className="prose-measure" style={{ whiteSpace: 'pre-wrap', color: 'var(--text)', fontSize: '0.9375rem' }}>
        {toCustomerCopy(answer.body)}
      </p>
    </div>
  );
}
